'use strict';

import axios from 'axios';

const API_URL = "https://api.ipify.org?format=json";

const IPAddress = {

    async get() {
		try {
            let response = await axios.get(API_URL);
            
			return response.data.ip;

		} catch(error) {
            return false;
		}
	}
    
}

export default IPAddress;